import { ref } from 'vue';
import { SearchTypeEnum } from '../types/SearchTypeEnum';

/**
 * Document Search Type Store
 *
 * Manages the current search type (name or prefix) for document searches.
 * This is part of the document entity as it represents document-specific search behavior.
 */

export const searchType = ref<'name' | 'prefix'>(SearchTypeEnum.DOCUMENT_NAME);

export const useDocumentSearchTypeStore = () => {
  const setSearchType = (type: 'name' | 'prefix') => {
    searchType.value = type;
  };

  const getSearchType = (): 'name' | 'prefix' => {
    return searchType.value;
  };

  return {
    searchType,
    setSearchType,
    getSearchType,
  };
};
